import React, { Suspense } from "react";
import withCustomStyles from "./HomePage.style";
import SimpleSliderPart from "../parts/SliderPart";
import { withRouter } from "react-router";
import ProductsHorizontalSectionPart from "../parts/ProductsHorizontalSectionPart";
import { inject, observer } from "mobx-react";
import { Helmet } from "react-helmet";
import { grocerAppDesc } from "../utils/SEOUtils";
import gtmService from "../services/GTMService";
import { Link } from "react-router-dom";
import OrderTilePart from "../parts/OrderTilePart";
import { lazyLoadComponentInViewPort } from "../utils/lazyLoadComponent";
import CategoriesHorizontalPart from "../parts/CategoriesHorizontalPart";
import { isEasyPaisaMiniApp, isSavyour } from "../utils/AppUtils";

import SEOInfoPart from "../parts/SEOInfoPart";
import CategoriesPart from "../parts/CategoriesPart";
import ProductsHorizontalSectionPartLazy from "../parts/ProductsHorizontalSectionPart";
import { getAppLink } from "../utils/UrlUtils";
import FooterContentPart from "../parts/FooterContentPart";
import TopBrandsPart from "../parts/TopBrandsPart";

// "Deals" disc in the category rail jumps to the deals rail
const DEALS_ANCHOR = "home-deals";

const GROCER_CLUB_BANNER =
  "https://pictures.grocerapps.com/original/grocerapp-grocer-club-free-deliveries-6aea0d9a9a1a4.jpeg";

@inject(["dealsStore"])
@inject(["customerStore"])
@inject(["memberShipStore"])
@inject(["paymentStore"])
@inject(["myOrdersStore"])
@inject(["productsStore"])
@inject(["globalSettingStore"])
@inject(["featuredProductsStore"])
@inject(["userBasedRecommendationsStore"])
@observer
class HomePage extends React.Component {
  state = {
    showScrollTopBtn: false
  };

  fetchAll() {
    const {
      myOrdersStore,
      globalSettingStore,
      customerStore,
      paymentStore
    } = this.props;
    if (customerStore.isLoggedIn) {
      customerStore.fetchCustomerWithWallet();
      myOrdersStore.fetchLastOrder();
      myOrdersStore.fetchPreviouslyOrderedProducts();
      paymentStore.fetchCreditCards();
    }

    globalSettingStore.registerDevice();
  }

  cancelAll() {
    const { myOrdersStore } = this.props;
    myOrdersStore.cancel();
  }

  componentDidMount() {
    this.fetchAll();
  }

  componentWillUnmount() {
    this.cancelAll();
  }

  trackInstallClick() {
    gtmService.event("User", "Home page app install banner clicked");
  }

  render() {
    const {
      props: {
        classes,
        dealsStore,
        productsStore,
        paymentStore: {
          cards,
          selectedCard,
          fetchCreditCards,
          fetchCreditCardState,
          selectedPaymentMethod,
          handlePaymentSelection
        },
        customerStore: { vendor, customer, isLoggedIn },
        globalSettingStore: { UANNUMBER },
        myOrdersStore,
        featuredProductsStore,
        userBasedRecommendationsStore
      },
      trackInstallClick
    } = this;

    const lazyOpts = offset => ({
      once: true,
      resize: true,
      style: { width: "100%" },
      offset
    });
    const dealsName = vendor.deals_section_name || "Top deals";

    const horizontalSecUnderBanner = (
      <div className={classes.stack}>
        <Suspense fallback={<div />}>
          <ProductsHorizontalSectionPartLazy
            name="Featured products"
            fetch={featuredProductsStore.fetch}
            cancel={featuredProductsStore.cancel}
            state={featuredProductsStore.fetchState}
            listName="Home Page - Featured Products"
            CTListName="Horizontal Section - Featured Products"
            products={featuredProductsStore.all}
          />
        </Suspense>
        {userBasedRecommendationsStore.all.length > 0 && (
          <Suspense fallback={<div />}>
            <ProductsHorizontalSectionPartLazy
              onScroll={userBasedRecommendationsStore.loadMore}
              name="More to love"
              fetch={userBasedRecommendationsStore.fetch}
              cancel={userBasedRecommendationsStore.cancel}
              state={userBasedRecommendationsStore.fetchState}
              listName="Home Page - More To Love"
              CTListName="Horizontal Section - More To Love"
              products={userBasedRecommendationsStore.all}
            />
          </Suspense>
        )}
        <TopBrandsPart />
      </div>
    );

    return (
      <>
        <Suspense fallback={<div />}>
          <SEOInfoPart />
          <Helmet>
            <script type="application/ld+json">
              {`[
                  {
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "url": "https://grocerapp.pk/",
                    "potentialAction": {
                      "@type": "SearchAction",
                      "target": "https://grocerapp.pk/search?q={search_term_string}",
                      "query-input": "required name=search_term_string"
                    }
                  },
                  {
                    "@context": "http://schema.org",
                    "@type": "Organization",
                    "name": "GrocerApp",
                    "description": "${grocerAppDesc()}",
                    "url": "https://grocerapp.pk",
                    "logo": "https://pictures.grocerapps.com/small/grocerapp-grocerapp-logo-698b56ad502f2.png",
                    "contactPoint": [{
                      "@type": "ContactPoint",
                      "telephone": "${UANNUMBER}",
                      "contactType": "customer service",
                      "areaServed": "PK",
                      "availableLanguage": "Urdu"
                    }],
                    "sameAs": [
                      "https://web.facebook.com/GrocerApp.pk",
                      "https://twitter.com/grocerapppk",
                      "https://www.instagram.com/grocerapp.pk",
                      "https://www.youtube.com/channel/UC8YtYLZMrsnpRsK8LzCNPOQ",
                      "https://www.linkedin.com/company/grocerapp"
                    ]
                  }
                ]`}
            </script>
            <link rel="canonical" href="https://grocerapp.pk" />
          </Helmet>
        </Suspense>
        <main className={classes.page}>
          <h1 className={classes.srOnly}>GrocerApp: online grocery delivery</h1>
          <CategoriesHorizontalPart
            dealsAnchor={dealsStore.all.length ? DEALS_ANCHOR : undefined}
          />
          {isLoggedIn &&
            myOrdersStore.lastOrder &&
            myOrdersStore.lastOrder.id && (
              <OrderTilePart
                cards={cards}
                selectedCard={selectedCard}
                order={myOrdersStore.lastOrder}
                fetchCreditCards={fetchCreditCards}
                retryOrderId={myOrdersStore.retryOrderId}
                fetchCreditCardState={fetchCreditCardState}
                onRetryPayment={myOrdersStore.retryPayment}
                onPaymentSelection={handlePaymentSelection}
                selectedPaymentMethod={selectedPaymentMethod}
                retryPaymentState={myOrdersStore.retryPaymentState}
              />
            )}
          {!isEasyPaisaMiniApp() && !isSavyour() && (
            <a
              onClick={trackInstallClick}
              className={classes.appBanner}
              href={getAppLink()}
              rel="noreferrer"
            >
              <img
                className={classes.bannerImg}
                alt="Get the GrocerApp mobile app"
                src={
                  "https://pictures.grocerapps.com/original/grocerapp-grocer-download-banner-6aeaf02969730.jpeg"
                }
                width="1774"
                height="887"
              />
            </a>
          )}
          {!isEasyPaisaMiniApp() && <SimpleSliderPart />}
          {isLoggedIn && myOrdersStore.previouslyOrderedList.length > 0 && (
            <ProductsHorizontalSectionPart
              name="Order again"
              listName="Home Page - Previously Order"
              fetch={myOrdersStore.fetchPreviouslyOrderedProducts}
              cancel={myOrdersStore.cancelPrevOrders}
              onScroll={myOrdersStore.loadMorePrevOrders}
              state={myOrdersStore.fetchPreviouslyOrderedProductsState}
              CTListName={"Horizontal Section - Previously Order"}
              products={myOrdersStore.previouslyOrderedList}
            />
          )}
          <ProductsHorizontalSectionPartLazy
            id={DEALS_ANCHOR}
            name={dealsName}
            listName="Home Page - Top Deals"
            fetch={dealsStore.fetch}
            cancel={dealsStore.cancel}
            state={dealsStore.fetchState}
            CTListName={`Horizontal Section - ${vendor.deals_section_name ||
              "Top Deals"}`}
            products={dealsStore.all}
          />
          {lazyLoadComponentInViewPort(horizontalSecUnderBanner, lazyOpts(500))}
          {!isEasyPaisaMiniApp() && !(customer && customer.is_member) && (
            <Link to={"/membership"} className={classes.memberBanner}>
              <img
                width="2170"
                height="725"
                alt="Join Membership"
                className={classes.bannerImg}
                src={GROCER_CLUB_BANNER}
              />
            </Link>
          )}
          {lazyLoadComponentInViewPort(
            <Suspense fallback={<div />}>
              <ProductsHorizontalSectionPartLazy
                name={"Fruits & vegetables"}
                listName="Home Page - Fruits & Vegetables"
                fetch={productsStore.fetchFruitsAndVegetables}
                onScroll={productsStore.loadMoreFruitsAndVegetables}
                cancel={productsStore.cancelFruitsAndVegetables}
                state={productsStore.fruitsAndVegetablesState}
                CTListName={"Horizontal Section - Fruits & Vegetables"}
                products={productsStore.fruitsAndVegetables}
              />
            </Suspense>,
            lazyOpts(400)
          )}
          {lazyLoadComponentInViewPort(
            <Suspense fallback={<div />}>
              <div className={classes.stack}>
                <ProductsHorizontalSectionPartLazy
                  name={"Daalain, rice & flour"}
                  listName="Home Page - Daalain, Rice & Flour"
                  fetch={productsStore.fetchDaalainAndRice}
                  onScroll={productsStore.loadMoreDaalainAndRice}
                  cancel={productsStore.cancelDaalainAndRice}
                  state={productsStore.daalainAndRiceState}
                  CTListName={"Horizontal Section - Daalain, Rice & Flour"}
                  products={productsStore.daalainAndRice}
                />
              </div>
            </Suspense>,
            lazyOpts(400)
          )}
          {lazyLoadComponentInViewPort(
            <Suspense fallback={<div />}>
              <section className={classes.allCategories}>
                <h2 className={classes.sectionTitle}>All categories</h2>
                <CategoriesPart headingTag="h3" />
              </section>
            </Suspense>,
            lazyOpts(500)
          )}
          <FooterContentPart />
        </main>
      </>
    );
  }
}

export default withRouter(withCustomStyles(HomePage));
